import { EnvironmentCp } from '@v2/environment/environment-cp';

export const environment: EnvironmentCp = {
  userApiUrl: `https://user-{env}.testowaplatforma123.net/`,
  walletApiUrl: `https://wallet-{env}.testowaplatforma123.net/`,
  paymentApiUrl: `https://payment-{env}.testowaplatforma123.net/`,
  envName: 'dev',
  apiVersion: ''
};
